<template>
    <div>
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
            <b-col lg="3">
                <b-form-group label="ASL" label-cols="4">
                    <b-form-select v-model="filtro.codiceAslServiceProvider" :options="opzioniAsl" />
                </b-form-group>
            </b-col>
            <b-col lg="3">
                <b-form-group label="idPai *" label-cols="4">
                    <b-form-input v-model="filtro.idPai" placeholder="Obbligatorio per sincronizzare" />
                </b-form-group>
            </b-col>
            <b-col lg="3">
                <b-form-group label="Dal" label-cols="4">
                    <date-picker format="YYYY-MM-DD" value-type="format" type="date" v-model="filtro.dataDa"></date-picker>
                </b-form-group>
            </b-col>
            <b-col lg="3">
                <b-form-group label="Al" label-cols="4">
                    <date-picker format="YYYY-MM-DD" value-type="format" type="date" v-model="filtro.dataA"></date-picker>
                </b-form-group>
            </b-col>
            <b-col lg="3" class="text-right">
                <b-button variant="outline-info btn-toolbar mr-1" @click="onClickSincronizza">
                    <i class="fas fa-cloud-download-alt"></i>
                    Aggiorna da AnDIamo
                </b-button>
                <b-button v-if="accessiSelezionatiMultiplo.length" variant="success btn-toolbar" @click="onClickErogaMultiplo">
                    <i class="fas fa-check-double"></i>
                    Eroga Multipla ({{ accessiSelezionatiMultiplo.length }})
                </b-button>
            </b-col>
        </b-row>

        <div class="mb-3 mt-2">
            <p>Totale Record: {{ andiamoAccessiRowsNumber }} — Raggruppati per PAI: {{ gruppiPerPai.length }}</p>
        </div>

        <!-- Lista completa raggruppata per idPai: ogni PAI e' una card, dentro
             ci sono TUTTI i suoi accessi (qualunque stato), non solo quelli
             erogabili - la scelta di cosa fare resta all'operatore. -->
        <div v-for="gruppo in gruppiPerPai" :key="gruppo.idPai" class="card sa-siat-card-pratica shadow-sm">
            <div class="sa-siat-card-header-custom">
                <b-row class="align-items-center">
                    <b-col cols="12" md="6">
                        <div class="sa-siat-label-pai">PAI</div>
                        <div class="h5 mb-0 text-primary">
                            #{{ gruppo.idPai }}
                            <span v-if="gruppo.dettaglio">— {{ gruppo.dettaglio.cognomeAssistito }} {{ gruppo.dettaglio.nomeAssistito }}</span>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6" class="text-right">
                        <span class="badge badge-pill badge-light border">{{ gruppo.accessi.length }} access{{ gruppo.accessi.length === 1 ? "o" : "i" }}</span>
                    </b-col>
                </b-row>
            </div>

            <div v-for="acc in gruppo.accessi" :key="acc.id" class="px-4 py-3" style="border-bottom: 1px solid #f0f0f0">
                <b-row class="align-items-center">
                    <b-col cols="12" md="3">
                        <div class="sa-siat-label-pai">Codice Accesso AnDIamo</div>
                        <div class="sa-siat-valore-pai">{{ acc.codiceAccesso }}</div>
                    </b-col>
                    <b-col cols="12" md="2">
                        <div class="sa-siat-label-pai">Stato</div>
                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + (acc.stato === 'finished' ? 'aperta' : 'da-programmare')">{{ acc.stato }}</span>
                    </b-col>
                    <b-col cols="12" md="3">
                        <div class="sa-siat-label-pai">Periodo</div>
                        <div>{{ formatDateTime(acc.dataOraInizio) }} - {{ formatDateTime(acc.dataOraFine) }}</div>
                    </b-col>
                    <b-col cols="12" md="2">
                        <div class="sa-siat-label-pai">Frequenza</div>
                        <div v-if="acc.frequenzaDettaglio" class="small">{{ acc.frequenzaDettaglio }}</div>
                        <div v-else class="text-muted">-</div>
                    </b-col>
                    <b-col cols="12" md="2" class="text-right"></b-col>
                </b-row>

                <!-- Prestazioni collegate a questo accesso (possono essere piu'
                     di una, stesso id_activity): selezionabili per erogazione
                     completa (tutte spuntate, default) o incompleta (solo
                     alcune). Erogata/Bloccata sono calcolate per singolo idPei
                     della prestazione, non per l'intero accesso. -->
                <div v-if="acc.prestazioniCollegate.length" class="mt-2 pl-3">
                    <div class="small font-weight-bold text-muted text-uppercase mb-1">Prestazioni:</div>
                    <div v-for="p in acc.prestazioniCollegate" :key="p.id" class="mb-1">
                        <b-form-checkbox v-if="!p.erogata && !p.bloccoMotivo" v-model="selezione[acc.id]" :value="p.id">
                            <span class="badge badge-outline-secondary mr-1">{{ p.codicePrestazione }}</span>
                            {{ p.descrizionePrestazione }}
                            <small v-if="trovaAttivitaCollegata(acc, p)" class="text-muted d-block">
                                {{ formatFrequenza(trovaAttivitaCollegata(acc, p).frequenza, trovaAttivitaCollegata(acc, p).periodo, trovaAttivitaCollegata(acc, p).periodUnit) }}
                                — {{ trovaAttivitaCollegata(acc, p).minutaggio }} min — {{ formatFiguraProfessionale(trovaAttivitaCollegata(acc, p).figuraProfessionaleCode) }}
                            </small>
                        </b-form-checkbox>
                        <div v-else>
                            <span class="badge badge-outline-secondary mr-1">{{ p.codicePrestazione }}</span>
                            {{ p.descrizionePrestazione }}
                            <span v-if="p.erogata" class="badge badge-success ml-1">Erogata</span>
                            <span v-else-if="p.bloccoMotivo" class="badge badge-danger ml-1" :title="p.bloccoMotivo"><i class="fas fa-lock"></i> Bloccata</span>
                            <div v-if="p.erogata && p.dettaglioErogazione" class="small text-muted">{{ formatDateTime(p.dettaglioErogazione.dataOraInizio) }} — Op: {{ p.dettaglioErogazione.codiceFiscaleOperatore }} — Acc: {{ p.dettaglioErogazione.codiceAccesso }}</div>
                        </div>
                    </div>
                    <div class="mt-2">
                        <b-button v-if="acc.erogabile" size="sm" variant="success" :disabled="!(selezione[acc.id] && selezione[acc.id].length)" @click="onClickRegistraErogazione(acc)">
                            <i class="fas fa-check-circle"></i>
                            Registra Erogazione ({{ selezione[acc.id] ? selezione[acc.id].length : 0 }}/{{ acc.prestazioniCollegate.length }})
                        </b-button>
                        <span v-else-if="acc.oltreDimissione" class="badge badge-danger" title="Data successiva alla dimissione del PAI"><i class="fas fa-lock"></i> Oltre dimissione PAI</span>
                        <span v-else-if="acc.stato === 'planned' && !acc.bloccatoDaSospensione" class="text-muted small">Data futura: non ancora erogabile</span>
                        <span v-if="bozzePerAccesso[acc.codiceAccesso]" class="badge badge-info ml-1" title="Bozza salvata, non ancora inviata">Bozza</span>
                        <template v-if="acc.erogabile && bozzePerAccesso[acc.codiceAccesso]">
                            <b-button size="sm" variant="outline-success" class="ml-1" @click="onClickInviaBozza(acc)">
                                <i class="fas fa-paper-plane"></i>
                                Eroga bozza
                            </b-button>
                            <b-button size="sm" variant="outline-danger" class="ml-1" @click="onClickEliminaBozza(acc)">
                                <i class="fas fa-trash"></i>
                            </b-button>
                        </template>
                    </div>
                </div>
                <div v-else class="mt-2 pl-3 text-muted small">Nessuna prestazione collegata (attivita' non ancora sincronizzata per questo PAI)</div>
            </div>
        </div>
        <no-data-component v-if="!gruppiPerPai.length" title="Nessun accesso locale: aggiorna da AnDIamo" :fontSize="15" :paddingSize="0.5" />

        <AndiamoErogazioneModalComponent ref="modalErogazione" :dettaglio="dettaglioPerAccessoCorrente" @registrata="onErogazioneRegistrata" @bozza="loadBozze" />
    </div>
</template>

<script>
import axios from "axios";
import AndiamoMixin from "../mixins/AndiamoMixin";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import DatePicker from "vue2-datepicker";
import AndiamoErogazioneModalComponent from "./AndiamoErogazioneModalComponent.vue";

export default {
    components: { NoDataComponent, DatePicker, AndiamoErogazioneModalComponent },
    mixins: [AndiamoMixin],
    data() {
        return {
            opzioniAsl: [
                { value: "150204", text: "150204" },
                { value: "150205", text: "150205" },
                { value: "150206", text: "150206" },
            ],
            filtro: {
                codiceAslServiceProvider: "150205",
                idPai: "",
                dataDa: "",
                dataA: "",
            },
            attivitaPerPai: {},
            prestazioniPerAccesso: {},
            eventiPerPai: {},
            erogazioniPerPai: {},
            bozzePerAccesso: {},
            dettaglioPerPai: {},
            dettaglioPerAccessoCorrente: null,
            // Checkbox selezionate per erogazione, per id accesso: array di id
            // di AndiamoPaiAttivitaBean (prestazioni) selezionate. Di default,
            // quando un accesso viene arricchito, parte con TUTTE selezionate
            // (erogazione completa) - l'operatore puo' togliere quelle che non
            // vuole erogare ora (parziale).
            selezione: {},
        };
    },
    computed: {
        accessiArricchiti() {
            let oggi = new Date();
            oggi.setHours(0, 0, 0, 0);
            return this.andiamoAccessiItems.map((acc) => {
                let frequenzaDettaglio = this.calcolaFrequenzaDettaglio(acc);
                let dataAccesso = acc.dataOraInizio ? new Date(acc.dataOraInizio) : null;
                let dettaglioPai = this.dettaglioPerPai[acc.idPai];
                let oltreDimissione = dettaglioPai && dettaglioPai.periodEnd && acc.dataOraInizio && acc.dataOraInizio.slice(0, 10) > dettaglioPai.periodEnd.slice(0, 10);
                let erogabile = acc.stato === "planned" && dataAccesso && dataAccesso <= oggi && !oltreDimissione;
                let prestazioniCollegate = this.trovaPrestazioniCollegate(acc).map((p) => {
                    let idPeiRiferimento = p.idPei || acc.idPei;
                    let erogazioniEsistenti = this.erogazioniPerPai[acc.idPai] || [];
                    let dettaglioErogazione = erogazioniEsistenti.find((erg) => erg.codiceAccesso === acc.codiceAccesso);
                    return {
                        ...p,
                        erogata: !!dettaglioErogazione,
                        dettaglioErogazione: dettaglioErogazione || null,
                        bloccoMotivo: this.calcolaBloccoPerPei(acc.idPai, idPeiRiferimento, acc.dataOraInizio),
                    };
                });
                if (this.selezione[acc.id] === undefined) {
                    this.$set(
                        this.selezione,
                        acc.id,
                        prestazioniCollegate.filter((p) => !p.erogata && !p.bloccoMotivo).map((p) => p.id),
                    );
                }
                return { ...acc, frequenzaDettaglio, erogabile, oltreDimissione, prestazioniCollegate };
            });
        },
        /**
         * "La lista erogazioni la devi popolare per idpai": raggruppa gli
         * accessi (che restano righe individuali, ognuno con il proprio
         * codice_accesso reale) sotto il PAI di appartenenza, mostrando
         * TUTTI gli accessi (qualunque stato), non filtrati solo su quelli
         * erogabili - la vista completa la decide di guardarla l'operatore.
         */
        gruppiPerPai() {
            let mappa = {};
            this.accessiArricchiti.forEach((acc) => {
                if (!acc.idPai) {
                    return;
                }
                if (!mappa[acc.idPai]) {
                    mappa[acc.idPai] = { idPai: acc.idPai, dettaglio: this.dettaglioPerPai[acc.idPai] || null, accessi: [] };
                }
                mappa[acc.idPai].accessi.push(acc);
            });
            return Object.values(mappa).sort((a, b) => a.idPai.localeCompare(b.idPai));
        },
        /**
         * Accessi scelti per l'invio multiplo, ciascuno con le sue
         * prestazioni GIA' selezionate tramite le checkbox esistenti
         * (this.selezione[acc.id]) - non tutte per forza, l'utente puo'
         * aver scelto erogazione parziale anche qui.
         */
        /**
         * CORRETTO: stesso bug della view PAI - prima usava una checkbox
         * separata scollegata dalle spunte prestazioni, risultando in un
         * batch a 0 anche con righe "selezionate". Ora usa direttamente le
         * spunte gia' presenti per l'erogazione singola.
         */
        accessiSelezionatiMultiplo() {
            return this.accessiArricchiti
                .filter((acc) => acc.erogabile)
                .map((acc) => {
                    let idSelezionati = this.selezione[acc.id] || [];
                    // distretto del PAI di questo accesso (dettaglio.codiceAslAutore): nella multipla gli accessi possono
                    // appartenere a PAI diversi, e la modale cerca operatori associati a tutti i distretti coinvolti
                    let distretto = (this.dettaglioPerPai[acc.idPai] || {}).codiceAslAutore || null;
                    return { accesso: acc, distretto: distretto, prestazioni: acc.prestazioniCollegate.filter((p) => idSelezionati.includes(p.id)) };
                })
                .filter((el) => el.prestazioni.length);
        },
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.andiamoCaricaAccessiPianificatiLocali(this.filtro, this.onAccessiCaricatiSuccess);
            this.loadBozze();
        },
        onAccessiCaricatiSuccess(response) {
            this.andiamoCaricaAccessiLocaliSuccess(response);
            let idPaiDistinti = [...new Set((this.andiamoAccessiItems || []).map((a) => a.idPai).filter(Boolean))];
            idPaiDistinti.forEach((idPai) => this.caricaDatiPaiSeNecessario(idPai));
        },
        caricaDatiPaiSeNecessario(idPai) {
            if (this.attivitaPerPai[idPai] || this.dettaglioPerPai[idPai]) {
                return;
            }
            let link = process.env.VUE_APP_PATH_API + this.andiamoPaiPathResource + "/" + idPai + "/locale";
            axios
                .get(link)
                .then((response) => {
                    let data = response.data.data;
                    this.$set(this.attivitaPerPai, idPai, data.attivita || []);
                    this.$set(this.eventiPerPai, idPai, data.eventi || []);
                    this.$set(this.dettaglioPerPai, idPai, data.dettaglio || null);
                })
                .catch(() => {
                    // Nessun dettaglio locale per questo PAI: normale se non e'
                    // mai stato scaricato. Frequenza/blocco restano
                    // semplicemente non disponibili per i suoi accessi.
                });
            // Prestazioni gia' erogate con successo (stato ACCETTATA), per il
            // cross-reference "Erogata".
            this.andiamoCaricaPrestazioniErogatePerPai(idPai, (response) => {
                this.closeShowModalLoading();
                this.$set(this.erogazioniPerPai, idPai, response.data.data || []);
            });
            // Prestazioni VERE collegate agli accessi di questo PAI (fonte
            // corretta, gesan_andiamo_accessi_prestazioni - non derivata da
            // pai_attivita, che e' un concetto diverso: la programmazione/
            // frequenza dal CarePlan, non cosa e' stato davvero comunicato
            // per un singolo accesso).
            let linkPrestazioni = process.env.VUE_APP_PATH_API + this.andiamoAccessiPrestazioniPathResource;
            axios
                .get(linkPrestazioni, { params: { idPai: idPai } })
                .then((response) => {
                    let lista = response.data.data.list || [];
                    let mappa = {};
                    lista.forEach((p) => {
                        if (!mappa[p.idAccesso]) {
                            mappa[p.idAccesso] = [];
                        }
                        mappa[p.idAccesso].push(p);
                    });
                    Object.keys(mappa).forEach((idAccesso) => this.$set(this.prestazioniPerAccesso, idAccesso, mappa[idAccesso]));
                })
                .catch(() => {
                    // Nessuna prestazione trovata per questo PAI: normale se gli
                    // accessi non hanno ancora prestazioni comunicate da AnDIamo
                    // (es. Encounter senza diagnosis).
                });
        },
        /**
         * Prestazioni REALI di questo specifico accesso (gesan_andiamo_accessi_prestazioni,
         * per idAccesso). CONFERMATO dall'utente: e' la fonte corretta, non
         * un derivato dalla programmazione del PAI.
         */
        trovaPrestazioniCollegate(acc) {
            return this.prestazioniPerAccesso[acc.id] || [];
        },
        /**
         * La frequenza-dettaglio resta invece dalla programmazione del PAI
         * (pai_attivita, via id_activity): e' un dato diverso dalle
         * prestazioni collegate sopra, serve solo per mostrare "ogni quanto"
         * e' previsto questo tipo di accesso.
         */
        /**
         * Collega una prestazione erogabile alla sua "attivita'" prevista
         * dal PAI (frequenza/minutaggio/figura professionale). Join doppio:
         * idActivity (= codiceInterno) + codicePrestazione, per non
         * confondere prestazioni diverse della stessa attivita' (dopo il
         * fix "prestazioni multiple").
         */
        /**
         * CONFERMATO da collaudo: dopo una Modifica PEI possono esistere
         * PIU' versioni della stessa attivita' (stesso codiceInterno+
         * codicePrestazione, boundsStart diverso) - non sovrascritte piu'
         * lato backend proprio per poterle distinguere qui. Sceglie quella
         * il cui periodo [boundsStart, boundsEnd] copre la data
         * dell'accesso, non semplicemente la prima trovata.
         */
        trovaAttivitaCollegata(acc, prestazione) {
            let attivita = this.attivitaPerPai[acc.idPai];
            if (!attivita || !acc.idActivity || !acc.dataOraInizio) {
                return null;
            }
            let dataAccesso = acc.dataOraInizio.slice(0, 10);
            let candidate = attivita.filter((a) => a.attivita && a.attivita.codiceInterno === acc.idActivity && a.attivita.codicePrestazione === prestazione.codicePrestazione);
            let match = candidate.find((a) => {
                let inizio = a.attivita.boundsStart ? a.attivita.boundsStart.slice(0, 10) : null;
                let fine = a.attivita.boundsEnd ? a.attivita.boundsEnd.slice(0, 10) : null;
                return (!inizio || dataAccesso >= inizio) && (!fine || dataAccesso <= fine);
            });
            // Se nessuna versione copre esattamente quella data (es. accesso
            // precedente alla primissima versione mai sincronizzata), usa
            // comunque la piu' vicina per data di inizio, invece di non
            // mostrare nulla.
            if (!match && candidate.length) {
                match = [...candidate].sort((a, b) => (b.attivita.boundsStart || "").localeCompare(a.attivita.boundsStart || ""))[0];
            }
            return match ? match.attivita : null;
        },
        calcolaFrequenzaDettaglio(acc) {
            let attivita = this.attivitaPerPai[acc.idPai];
            if (!attivita || !acc.idActivity || !acc.dataOraInizio) {
                return null;
            }
            let dataAccesso = acc.dataOraInizio.slice(0, 10);
            let candidate = attivita.filter((a) => a.attivita && a.attivita.codiceInterno === acc.idActivity);
            let match = candidate.find((a) => {
                let inizio = a.attivita.boundsStart ? a.attivita.boundsStart.slice(0, 10) : null;
                let fine = a.attivita.boundsEnd ? a.attivita.boundsEnd.slice(0, 10) : null;
                return (!inizio || dataAccesso >= inizio) && (!fine || dataAccesso <= fine);
            });
            if (!match && candidate.length) {
                match = [...candidate].sort((a, b) => (b.attivita.boundsStart || "").localeCompare(a.attivita.boundsStart || ""))[0];
            }
            if (!match) {
                return null;
            }
            let att = match.attivita;
            return this.formatFrequenza(att.frequenza, att.periodo, att.periodUnit);
        },
        /**
         * Blocco erogazione per un singolo PEI (Sospensione/Riattivazione/
         * Modifica PEI sono eventi specifici per idPei, CONFERMATO su dato
         * reale - non vanno applicati indistintamente a tutto il PAI).
         * Restituisce il motivo del blocco o null se erogabile.
         */
        calcolaBloccoPerPei(idPai, idPei, dataOraInizioAccesso) {
            let eventi = this.eventiPerPai[idPai];
            if (!eventi || !eventi.length || !idPei || !dataOraInizioAccesso) {
                return null;
            }
            let dataAccesso = dataOraInizioAccesso.slice(0, 10);
            let eventiPei = eventi.filter((e) => e.idPei === idPei);

            let sospensioni = eventiPei.filter((e) => e.tipoEvento === "Sospensione" && e.dataSospensione).map((e) => e.dataSospensione.slice(0, 10));
            let riattivazioni = eventiPei.filter((e) => e.tipoEvento === "Riattivazione" && e.dataRiattivazione).map((e) => e.dataRiattivazione.slice(0, 10));
            for (let inizioSospensione of sospensioni) {
                if (dataAccesso < inizioSospensione) {
                    continue;
                }
                let riattivatoPrimaDellAccesso = riattivazioni.some((r) => r >= inizioSospensione && r <= dataAccesso);
                if (!riattivatoPrimaDellAccesso) {
                    return "PAI sospeso dal " + inizioSospensione.split("-").reverse().join("/");
                }
            }

            let modifichePei = eventiPei.filter((e) => e.tipoEvento === "Modifica PEI" && e.dataEvento).map((e) => e.dataEvento.slice(0, 10));
            if (modifichePei.length) {
                let ultimaModifica = modifichePei.sort().pop();
                if (dataAccesso < ultimaModifica) {
                    return "PEI modificato il " + ultimaModifica.split("-").reverse().join("/") + ": erogabile solo da quella data";
                }
            }

            return null;
        },
        onClickSincronizza() {
            if (!this.filtro.codiceAslServiceProvider) {
                this.$bvToast.toast("Indica il codice ASL prima di sincronizzare", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            // CONFERMATO da collaudo: una sync SENZA idPai salva in locale
            // TUTTI gli accessi dell'ASL/HCP, di qualunque PAI - un accesso
            // di un altro PAI (anche di un'altra ASL) puo' cosi' finire nel
            // database e riemergere in contesti sbagliati. idPai e' ora
            // obbligatorio, ogni sync resta sempre scoperta a un solo PAI.
            if (!this.filtro.idPai) {
                this.$bvToast.toast("Indica l'idPai prima di sincronizzare: una sync senza idPai porterebbe dentro accessi di altri PAI", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            this.andiamoSincronizzaAccessi({ codiceAsl: this.filtro.codiceAslServiceProvider, idPai: this.filtro.idPai, dataDa: this.filtro.dataDa, dataA: this.filtro.dataA });
        },
        /**
         * Registra l'erogazione SOLO per le prestazioni spuntate di questo
         * accesso (checkbox in selezione[acc.id]): tutte spuntate = erogazione
         * completa, solo alcune = incompleta. Il codiceAccesso resta unico
         * (quello vero di AnDIamo per questa riga), cambia solo quali
         * prestazioni vengono incluse nel body.
         */
        onClickRegistraErogazione(acc) {
            let idSelezionati = this.selezione[acc.id] || [];
            let prestazioniSelezionate = acc.prestazioniCollegate.filter((p) => idSelezionati.includes(p.id));
            if (!prestazioniSelezionate.length) {
                this.$bvToast.toast("Seleziona almeno una prestazione", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            // Senza il dettaglio del PAI NON si inventa codiceAslAutore: li' c'e' il CODICE DISTRETTO e metterci l'ASL
            // farebbe cercare operatori associati a un "distretto" inesistente (elenco sempre vuoto).
            this.dettaglioPerAccessoCorrente = this.dettaglioPerPai[acc.idPai] || { idPai: acc.idPai };
            this.$refs.modalErogazione.apri(prestazioniSelezionate, acc);
        },
        /**
         * "Erogazione multipla": piu' accessi distinti in un solo click.
         * Ogni accesso selezionato deve gia' avere le sue prestazioni
         * spuntate tramite le checkbox esistenti (erogazione totale o
         * parziale, per accesso, restano indipendenti anche qui).
         */
        onClickErogaMultiplo() {
            if (!this.accessiSelezionatiMultiplo.length) {
                this.$bvToast.toast("Nessuno degli accessi selezionati ha almeno una prestazione spuntata", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            let primoIdPai = this.accessiSelezionatiMultiplo[0].accesso.idPai;
            this.dettaglioPerAccessoCorrente = this.dettaglioPerPai[primoIdPai] || { idPai: primoIdPai };
            this.$refs.modalErogazione.apriMultiplo(this.accessiSelezionatiMultiplo);
        },
        /**
         * Bozze di erogazione salvate (stato BOZZA), indicizzate per codiceAccesso.
         * Nessun filtro per idPai: questa lista raggruppa piu' PAI, quindi si
         * caricano tutte le bozze insieme. Una bozza non e' mai "erogata".
         */
        loadBozze() {
            let me = this;
            axios
                .get(process.env.VUE_APP_PATH_API + me.andiamoErogazioniPathResource + "/locali", { params: { stato: "BOZZA", page: 1, forPage: 1000 } })
                .then((response) => {
                    let mappa = {};
                    (response.data.data.list || []).forEach((b) => {
                        mappa[b.codiceAccesso] = b;
                    });
                    me.bozzePerAccesso = mappa;
                })
                .catch(() => {});
        },
        onClickInviaBozza(item) {
            let bozza = this.bozzePerAccesso[item.codiceAccesso];
            this.$bvModal.msgBoxConfirm("Inviare ad AnDIamo l'erogazione salvata per l'accesso " + item.codiceAccesso + "?", { title: "Eroga bozza", okTitle: "Eroga", cancelTitle: "Annulla" }).then((conferma) => {
                if (!conferma) return;
                this.openShowModalLoading();
                axios
                    .post(process.env.VUE_APP_PATH_API + this.andiamoErogazioniPathResource + "/bozza/" + bozza.id + "/eroga")
                    .then((response) => {
                        this.closeShowModalLoading();
                        this.$bvToast.toast(response.data.messaggio || "Erogazione inviata", { title: "", variant: "success", solid: true });
                        this.loadData();
                    })
                    .catch((error) => {
                        this.closeShowModalLoading();
                        this.$bvToast.toast(error?.response?.data?.messaggio || error.message, { title: "Erogazione non inviata", variant: "danger", solid: true });
                        this.loadData();
                    });
            });
        },
        onClickEliminaBozza(item) {
            let bozza = this.bozzePerAccesso[item.codiceAccesso];
            this.$bvModal.msgBoxConfirm("Eliminare la bozza dell'accesso " + item.codiceAccesso + "?", { title: "Elimina bozza", okTitle: "Elimina", okVariant: "danger", cancelTitle: "Annulla" }).then((conferma) => {
                if (!conferma) return;
                axios
                    .delete(process.env.VUE_APP_PATH_API + this.andiamoErogazioniPathResource + "/bozza/" + bozza.id)
                    .then(() => this.loadBozze())
                    .catch((error) => this.$bvToast.toast(error?.response?.data?.messaggio || error.message, { title: "Bozza non eliminata", variant: "danger", solid: true }));
            });
        },
        onErogazioneRegistrata() {
            this.loadData();
        },
    },
};
</script>

<style scoped>
.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;
}
.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;
}
.sa-siat-label-pai {
    font-weight: bold;
    color: #7f8c8d;
    text-transform: uppercase;
    font-size: 0.85rem;
}
.sa-siat-valore-pai {
    color: #2c3e50;
    font-weight: 600;
}
.sa-siat-badge {
    display: inline-block;
    font-size: 0.9rem;
}
.sa-siat-badge-aperta {
    color: #07af07;
}
.sa-siat-badge-da-programmare {
    color: #e67e22;
}
</style>
